<template>
    <div class="point-block">
        <div class="wrapper">
            <div class="left">
                <div class="img">
                    <img src="static/img/main/point2/img.png" alt="">
                </div>
                <div class="img-over point-img2">
                    <img src="static/img/main/point2/img-over.png" alt="">
                </div>
                <div class="square"></div>
            </div>
            <div class="right">
                <span class="quotes quotes-right">
                    <span class="text">
                        Все мои поездки в&nbsp;эту страну были связаны со&nbsp;сноубордингом, тренировками в&nbsp;горах и&nbsp;наслаждением природой
                    </span>
                </span>
                <div class="info">
                    <span class="point">
                        <span class="text">
                            Базель, Швейцария
                        </span>
                    </span>
                    <h3 class="head">
                        Базель — историческая <br>
                        родина Weleda
                    </h3>
                    <span class="desc">
                        Сегодня Базель не сходит с газетных полос: в городе, расположенном между...
                    </span>
                    <a href="#" class="btn" @click.prevent="openPopup">
                        Смотреть
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     viewBox="0 0 87.2 65.2" style="enable-background:new 0 0 87.2 65.2;" xml:space="preserve">
                                    <path class="st0" d="M85,34c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.2l0.1-0.2l0.1-0.2l0.1-0.2c0.1-0.3,0.1-0.5,0-0.8l-0.1-0.2l-0.1-0.2
                                        l-0.1-0.2l-0.1-0.2C85.1,31.2,85,31.1,85,31L56,2c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8l25.6,25.8H3.6c-1.1,0-2,0.9-2,2
                                        c0,1.1,0.9,2,2,2h75.2L53.2,60.2c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l0,0L85,34z"/>
                                </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap';
    import Helpers from '@/tools/Helpers';
    export default {
        name: 'point2',
        methods: {
            gaEvents(ctegory,event,label){
                Helpers.ga().send(ctegory,event,label);
            },
            openPopup() {
                this.$store.commit('SET_POPUP', 'popup2');
                this.gaEvents('places','click','show 2');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// point2.vue?20fb87a1